import type { Entitlement } from './types';

// La PASARELA de usuarios, en una función pura: ¿este usuario puede usar el
// producto descargable? (independiente de si además es cliente hosted).
export function hasDownloadableAccess(e: Entitlement | null | undefined, now: number = Date.now()): boolean {
  if (!e) return false;
  if (e.status === 'active') return true;
  if (e.status !== 'trialing') return false;
  // Trial SIN tarjeta (D16): no hay webhook que lo caduque — la web comprueba
  // current_period_end. Los 'trialing' de Stripe los caduca el webhook.
  if (!e.viaStripe) {
    const end = e.currentPeriodEnd ? Date.parse(e.currentPeriodEnd) : NaN;
    if (Number.isFinite(end) && end <= now) return false;
  }
  return true;
}

// Intelligence: cuota diaria GRATIS del descargable. 0.6.4 (doc 17 §3): pasa
// de 5/día (decisión 2026-07-08, db/migrations/003) a 1/día — las búsquedas
// extra se pagan con tokens ganados mapeando (RPCs dl_*, migraciones 063+).
// Este valor es solo el fallback de pintado: la UI prefiere free_searches_left
// del RPC dl_intelligence_status cuando llega.
export const DOWNLOADABLE_INTELLIGENCE_QUOTA = 1;

export function intelligenceDailyQuota(e: Entitlement | null | undefined): number {
  if (!hasDownloadableAccess(e)) return 0;
  return DOWNLOADABLE_INTELLIGENCE_QUOTA;
}

export function isIntelligenceAllowed(e: Entitlement | null | undefined): boolean {
  return intelligenceDailyQuota(e) > 0;
}

export function entitlementLabel(e: Entitlement | null | undefined): string {
  if (!e) return 'Sin suscripción';
  switch (e.status) {
    case 'active': return 'Suscripción activa';
    case 'trialing': return 'En prueba';
    case 'past_due': return 'Pago pendiente';
    case 'canceled': return 'Cancelada';
    default: return 'Sin suscripción';
  }
}
